import './telematicsVideoPlayer.css';
import PopupModel from "../../../shared/popupModel/popupModel";
import Slider from "react-slick";
import {videos} from '../../../data/videosData';

const TelematicsVideoPlayer = ({handleShowVideoPlayer, index}) => {

    const tags = videos

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        initialSlide: index
    };

    return (
        <PopupModel classes={'width-900'} showPopupModel={handleShowVideoPlayer}>
            <ul className={'telematics-video-player telematics-videos-list'}>
                <Slider  {...settings}>
                    {
                        tags.map((video, videoIndex) =>
                            <li key={videoIndex} className={'telematics-video'}>
                                <div className="icon width-block-100 margin-b-10">
                                    <img src={video.img} alt=""/>
                                </div>
                                <div className="font-14 flex">
                                    <div className="flex gap-15 sf-medium">
                                        <div className="rating-box">{video.tag}</div>
                                        <div className="font-15"><span className={'margin-r-15'}>19:27</span> 15 Sep
                                            2023
                                        </div>
                                    </div>
                                    <ul className="separator gap-30 sf-bold">
                                        <li>KA 02 N 9023</li>
                                        <li>Driver: <span className={'blue-color'}>Babu K</span></li>
                                    </ul>
                                    <div className="grey-color sf-medium">Eicher/HMV Chennai - Ahmedabad</div>
                                </div>
                            </li>
                        )
                    }
                </Slider>

            </ul>
        </PopupModel>
    )
}

export default TelematicsVideoPlayer;
